import React, { useState, useEffect } from "react";
import {
  Search,
  Minus,
  Plus,
  X,
  ChevronLeft,
  ChevronRight,
  Trash2
} from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import ImageGallery from "./ImageGallery";
import { decryptData } from "../../../utils/storageCrypto";

const AddItems = ({ isOpen, onClose, MRDetails, setMRItemsPoupMessage, setPopupType, fetchMrItems, setShowPopup }) => {
  const [pricingModel, setPricingModel] = useState("general");
  const [searchQuery, setSearchQuery] = useState("");
  const [items, setItems] = useState([]);
  const [currentImage, setCurrentImage] = useState(0);
  const [allProducts, setAllProducts] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [zoom, setZoom] = useState(false);

 console.log(MRDetails)
  const fetchurl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const imageurl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;

  useEffect(() => {
    if (isOpen) {
      fetchAllItems();
    }
  }, [isOpen]);

  const fetchAllItems = async () => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedhubId = sessionStorage.getItem('hubId');
              const hubId = decryptData(encryptedhubId);

      if (!hubId) {
        console.error("hub ID not found in sessionStorage.");
        return;
      }

      const response = await fetch(
        `${fetchurl}product/get-all-products?hub_id=${hubId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );

      const data = await response.json();
      console.log("Fetched Products:", data);
      if (data.success && data.data) {
        setAllProducts(data.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const attachments = MRDetails?.material_list_attachments || [];

  const handlePrevImage = () => {
    setCurrentImage((prev) =>
      prev === 0 ? attachments.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImage((prev) =>
      prev === attachments.length - 1 ? 0 : prev + 1
    );
  };


/* const handleQuantityChange = (id, value, index) => {
  setItems((prev) => {
    const newItems = [...prev];
    const item = newItems[index];
    if (item && item.id === id) { // Safety check with id
      newItems[index] = {
        ...item,
        quantity: typeof value === 'number'
          ? Math.max(1, value) // Direct input: set to the number, min 1
          : value === "inc"
            ? item.quantity + 1 // Increment
            : Math.max(1, item.quantity - 1), // Decrement, min 1
      };
    }
    return newItems;
  });
}; */

const handleQuantityChange = (id, value, index) => {
  setItems((prev) => {
    const newItems = [...prev];
    const item = newItems[index];

    // If quantity is 1 and action is 'dec', remove the item
    if (item.quantity === 1 && value === "dec") {
      return newItems.filter((_, i) => i !== index);
    }

    // Otherwise, update the quantity
    newItems[index] = {
      ...item,
      quantity:
        typeof value === "number"
          ? Math.max(1, value) // Direct input: ensure min 1
          : value === "inc"
          ? item.quantity + 1 // Increment
          : Math.max(1, item.quantity - 1), // Decrement, min 1
    };

    return newItems;
  });
};


  const handleAddItem = () => {
  const trimmedName = searchQuery.trim();
  if (!trimmedName) return;

  const existing = items.find(
    (item) => item.name.toLowerCase() === trimmedName.toLowerCase()
  );

  if (existing) {
    console.log("✅ Item already exists. Increasing quantity:", existing);
    handleQuantityChange(existing.id, "inc");
    setSearchQuery("");
    setShowSuggestions(false);
    return;
  }

  const foundProduct = allProducts.find(
    (p) => p.product_name.toLowerCase() === trimmedName.toLowerCase()
  );

  console.log("🔍 Found Product:", foundProduct);

  let newItem = {
  name: foundProduct ? foundProduct.product_name : trimmedName,
  image: foundProduct?.product_image ? `${imageurl}${foundProduct.product_image}` : null,
  quantity: 1,
  is_available: true
};

 if (foundProduct){
  newItem.product_id = foundProduct._id
  newItem.UOM_id = foundProduct.UOM_id
  newItem.product_category_id = foundProduct.product_category_id._id
 }else{
 newItem.is_available = false
 }

  console.log("🆕 Adding Item:", newItem);
  if (foundProduct?.product_image) {
    console.log("📸 Item has image:", newItem.image);
  } else {
    console.log("⚠️ Item has no image, using placeholder");
  }

  setItems((prev) => [...prev, newItem]);
  setSearchQuery("");
  setShowSuggestions(false);
};


// Inside AddItems component, above the return statement

const handleSaveItems = async () => {
  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);


    if (!items.length) {
      console.log("No items to save!");
      return;
    }
   console.log(items)
    const MR_Data = {
      material_requirement_id: MRDetails._id,
      price_eligibility: pricingModel === 'project' ? 'Project Pricing' : 'General Pricing',
      product_category_ids: [...new Set(items.map(item => item.product_category_id))],
      items: items.map(item => ({
        ...item,
        product_name: item.name,
      })),
    };

    console.log("Payload to send:", MR_Data);

    // Call backend
    const response = await fetch(
      `${fetchurl}customer/material-requirement/update-material-requirement-items`,
      {
        method: "POST",
        headers: {
          "x-token": token,
          "Content-Type": "application/json", // IMPORTANT
        },
        body: JSON.stringify({
          MRId: MRDetails._id,
          MR_items: MR_Data,
        }),
      }
    );

    const data = await response.json();
    console.log("Save Items Response:", data);

    if (data.success) {
      onClose(); // Close popup
     setMRItemsPoupMessage(data.message)
     setPopupType("200or201")
     setShowPopup(true)
     fetchMrItems(MRDetails._id)
     setItems([])
    } else {
      console.log("Failed to save Material Requirement:", data.message);
    }
  } catch (error) {
    console.error("Error saving items:", error);
  }
};



  const filteredProducts =
    allProducts.filter((item) =>
      item.product_name
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase())
    ) || [];

  if (!isOpen) return null;

  return (
  <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl w-full max-w-7xl max-h-[90vh] flex flex-col overflow-hidden shadow-2xl">
      
      {/* Header */}
      <div className="flex justify-between items-center px-5 py-4 border-b border-gray-100">
        <h2 className="text-lg font-semibold text-gray-800">Add Material Requirement Items</h2>
       <button
  onClick={() => {
    onClose();
    setItems([]);
  }}
  className="p-2 hover:bg-gray-100 rounded-full transition"
>
  <X size={20} className="text-gray-600" />
</button>

      </div>

      {/* Main Content */}
      <div className="flex  overflow-hidden ">
        
      
       {/* Left Section - Image Display */}
      <div className="w-1/2 flex items-center justify-center p-2">
  <ImageGallery attachments={attachments} fetchurl={fetchurl} />
</div>


        {/* Right Section */}
        <div className="w-1/2 flex flex-col bg-white px-8 py-5 overflow-hidden">

          {/* Pricing Type */}
          <div className="mb-6">
            <p className="text-sm font-semibold text-gray-800 mb-2">Select Pricing Type</p>
            <div className="flex gap-3">
              {["project", "general"].map((type) => (
                <div
                  key={type}
                  className={`flex items-center gap-2 px-4 py-2 rounded-xl border transition-all duration-200 cursor-pointer ${
                    pricingModel === type
                      ? "border-blue-600 bg-blue-50 shadow-sm"
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                  onClick={() => setPricingModel(type)}
                >
                  <div
                    className={`w-3 h-3 rounded-full ${
                      pricingModel === type ? "bg-blue-600" : "bg-gray-300"
                    }`}
                  ></div>
                  <span
                    className={`text-sm font-medium ${
                      pricingModel === type ? "text-blue-700" : "text-gray-700"
                    }`}
                  >
                    {type === "project" ? "Project Pricing" : "Quick Pricing"}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Search + Add Item */}
          <div className="flex items-start gap-3 mb-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-3 text-gray-400" size={18} />
              <input
  type="text"
  placeholder="Search or add an item..."
  value={searchQuery}
  onChange={(e) => {
    setSearchQuery(e.target.value);
    setShowSuggestions(true);
  }}
  className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-xl outline-none focus:border-gray-400 focus:ring-1 focus:ring-gray-400 text-sm transition"
/>

              {showSuggestions && searchQuery && (
                <div className="absolute bg-white border border-gray-200 rounded-xl mt-1 w-full shadow-lg z-10 max-h-48 overflow-y-auto">
                  {filteredProducts.length > 0 ? (
                    filteredProducts.map((item) => (
                      <div
                        key={item._id}
                        onClick={() => {
                          setSearchQuery(item.product_name);
                          setShowSuggestions(false);
                        }}
                        className="px-4 py-2 hover:bg-blue-50 cursor-pointer text-sm text-gray-700"
                      >
                        {item.product_name}
                      </div>
                    ))
                  ) : (
                    <div className="px-4 py-2 text-sm text-gray-500">No items found</div>
                  )}
                </div>
              )}
            </div>

            <button
              onClick={handleAddItem}
              className="text-sm font-medium py-2 px-4 rounded-md border border-[#f7525a] text-[#f7525a] bg-white hover:bg-[#f7525a] hover:text-white transition-colors duration-200 shadow-sm"
            >
              Add Item
            </button>
          </div>

          {/* Added Items */}
          {/* <div className="flex-1 overflow-y-auto mb-4 space-y-3">
            {items.map((item, index) => (
              <div
                key={item.id}
                className="flex items-center justify-between border border-gray-100 rounded-xl p-3 hover:shadow-sm bg-white transition"
              >
                <div className="flex items-center gap-3">
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-10 h-10 rounded-md object-cover"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-md bg-gray-200 flex items-center justify-center">
                      <FontAwesomeIcon icon={faImage} className="text-gray-400" />
                    </div>
                  )}
                  <span className="font-medium text-gray-800 text-sm">{item.name}</span>
                </div>


                 <QuantitySelector
    item={item} // Pass the item object
    quantity={item.quantity}
    handleQuantityChange={handleQuantityChange}
    min={1} // Optional
    max={100} // Optional
    index={index}
  />
  
              </div>
            ))}
          </div> */}

         

<div className="flex-1 overflow-y-auto mb-4 space-y-3">
  {items.map((item, index) => (
    <div
      key={item.id}
      className="flex items-center justify-between border border-gray-100 rounded-xl p-3 hover:shadow-sm bg-white transition"
    >
      {/* Left: Image + Name */}
      <div className="flex items-center gap-3">
        {item.image ? (
          <img
            src={item.image}
            alt={item.name}
            className="w-10 h-10 rounded-md object-cover"
          />
        ) : (
          <div className="w-10 h-10 rounded-md bg-gray-200 flex items-center justify-center">
            <FontAwesomeIcon icon={faImage} className="text-gray-400" />
          </div>
        )}
        <span className="font-medium text-gray-800 text-sm">{item.name}</span>
      </div>

      {/* Right: QuantitySelector + Delete Button */}
      <div className="flex items-center gap-2">
        <QuantitySelector
          item={item}
          quantity={item.quantity}
          handleQuantityChange={handleQuantityChange}
          min={1}
          max={100}
          index={index}
        />

        <button
          onClick={() => {
            setItems((prev) => prev.filter((_, i) => i !== index));
          }}
          className="p-2 hover:bg-red-50 rounded-full transition"
          title="Remove item"
        >
          <Trash2 className="w-4 h-4 text-red-500" />
        </button>
      </div>
    </div>
  ))}
</div>


          {/* Footer Buttons */}
          <div className="flex justify-end gap-3 border-t pt-4 mt-auto">
            <button
              onClick={() => {
                onClose();
                setItems([]);
              }}
              className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition"
            >
              Cancel
            </button>
            <button
              onClick={handleSaveItems}
              className="px-5 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition"
            >
              Save Items
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

};


const QuantitySelector = ({ item, quantity, handleQuantityChange, min = 1, max = Infinity, index }) => {
  const [inputValue, setInputValue] = useState(quantity.toString());

  // Sync inputValue with quantity when quantity changes (e.g., from buttons)
  useEffect(() => {
    setInputValue(quantity.toString());
  }, [quantity]);

  // Handle input change (allow any typing, including clearing)
  const handleInputChange = (e) => {
    setInputValue(e.target.value); // Update local state freely
  };

  // Handle blur (validate and update parent)
  const handleInputBlur = () => {
    const numValue = parseInt(inputValue, 10);
    let finalValue;
    if (isNaN(numValue) || numValue < min) {
      finalValue = min; // Clamp to min if invalid or too low
    } else if (numValue > max) {
      finalValue = max; // Clamp to max if too high
    } else {
      finalValue = numValue; // Valid number
    }
    handleQuantityChange(item.id, finalValue, index); // Update parent
    setInputValue(finalValue.toString()); // Sync local state
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => handleQuantityChange(item.id, "dec", index)}
        className="w-7 h-7 flex items-center justify-center border border-gray-300 rounded-full hover:bg-gray-100"
       // disabled={quantity <= min}
      >
        <Minus size={14} />
      </button>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        className="w-12 text-center text-sm border border-gray-300 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-500"
        min={min}
        max={max}
      />
      <button
        onClick={() => handleQuantityChange(item.id, "inc", index)}
        className="w-7 h-7 flex items-center justify-center border border-gray-300 rounded-full hover:bg-gray-100"
        disabled={quantity >= max}
      >
        <Plus size={14} />
      </button>
    </div>
  );
};




export default AddItems;



